import gql from "graphql-tag";

const USER_AUTHORIZATION = gql`
  mutation authorize($password: String!, $onlyForRoles: [String]) {
    authorize(password: $password, onlyForRoles: $onlyForRoles)
  }
`;

export default USER_AUTHORIZATION;
